module.exports = __webpack_public_path__ + "statics/img/cate8-5@2x.6fb2635d.png";